<template>
<div class="chapter">
<div class="inner_page">
<a id="page_3"></a>
<div class="img_container">
<img alt="images" src="images/title.jpg"/>
</div>
<p class="subtitle"><em class="italic">The Tyrant King Who Had Six Wives</em></p>
<div class="img_container">
<img alt="images" src="images/line.jpg"/>
</div>
<p class="author">Paul Kendall</p>
<div class="img_containerp">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003_Title.vue?fe74458a